import { keepPreviousData, queryOptions } from "@tanstack/react-query";

import { defaultServices } from "~/services";
import { BaseQuery } from "~/@types";
import { Cooperation } from "~/features/cooperation";

export const fetchListCooperation = async (q: BaseQuery) => {
  const res = await defaultServices.getList<Cooperation>({
    resource: "/cooperation",
    query: {
      ...q,
    },
  });

  return res;
};

export const getListCooperation = (q: BaseQuery) =>
  queryOptions({
    queryKey: ["cooperation", { ...q }],
    queryFn: () => fetchListCooperation(q),
    placeholderData: keepPreviousData,
  });
